import { useEffect } from 'react';

import { api } from 'api';

/**
 * get hex from string
 * PAY.NEVSKYCENTRE.RU/43B31E20A29F6A/PAY
 * https://pay.newvskii.ru/436347457457482412?123
 * @param val
 */
const getHex = (val) => {
  //const hexRegexp = /(([A-F0-9]{2}){7}|([A-F0-9]{2}){8}|([A-F0-9]{2}){9}|([A-F0-9]{2}){10})/g;
  const hexRegexp = /(([A-F0-9]{2}){5,10})/g;
  if (!val) {
    return val;
  }

  const matches = val.match(hexRegexp);
  if (matches && matches.length) {
    val = matches[0];
  }
  return val;
};

const timeoutBetweenKeys = 1200;
const minLength = 6;
const endChar = '!';
let timer = null;
let working = false;
let keys = '';

export const KeyInterceptor = () => {
  /**
   * set events
   */
  useEffect(() => {
    window.addEventListener('keydown', keyDownHandler);
    window.addEventListener('paste', getPaste);

    return () => {
      window.removeEventListener('keydown', keyDownHandler);
      window.removeEventListener('paste', getPaste);
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, []);

  /**
   * find from paste
   * @param {*} event
   * @returns
   */
  const getPaste = (event) => {
    if (event.target.name !== undefined || working) {
      return;
    }
    const v = event.clipboardData.getData('Text') + endChar;
    const isEnd = v.length >= minLength;
    if (isEnd) {
      keys = v;
      findParking();
    }
  };

  /**
   * on keydown handler
   * @param {*} event
   * @returns
   */
  const keyDownHandler = (event) => {
    if (event.target.name !== undefined) {
      return;
    }

    const val = event.keyCode;

    // end
    if (val === 13) {
      if (keys.length < 6) {
        keys = '';
      } else {
        keys += endChar;
      }
    } else {
      // keys = '';
      keys += String.fromCharCode(val);
    }

    // tests
    check();
  };

  /**
   * on keydown check
   */
  const check = () => {
    if (!working) {
      if (timer) {
        clearTimeout(timer);
      }
      if (keys) {
        const isEnd = keys.length >= minLength && keys[keys.length - 1] === endChar;
        if (isEnd) {
          findParking();
        } else {
          // clear keys if timer completed
          timer = setTimeout(() => {
            keys = '';
          }, timeoutBetweenKeys);
        }
      }
    }
  };

  /**
   * prepare find string
   * @param {*} v
   * @returns
   */
  const prepareFindString = (v) => {
    let out = v.substring(0, keys.length - 1);
    if (out.indexOf('/') !== -1) {
      out = getHex(out);
    }
    return out;
  };

  /**
   * find parking by meanId
   */
  const findParking = () => {
    const meanId = prepareFindString(keys);
    console.log('🚀 ~ findParking ~ meanId', meanId);

    if (working) {
      return;
    }

    working = true;

    api
      .call('stays.list', {
        filter_params: { mean_number: meanId },
        sort_params: [{ field_name: 'entry_at', direction: 'desc' }],
        paging_params: { limit: 1, offset: 0 },
      })
      .then((data) => {
        if (data && data.items && data.items.length) {
          const item = data.items[0];
          window.location.assign('/card/stay?id=' + item.id);
          return;
        }
        working = false;
        keys = '';
      })
      .finally(() => {
        working = false;
        keys = '';
      });
  };

  return null;
};
